import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { Permission } from 'garaje/utils/ui-permissions';

export default class VisitorsConfigurationAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;

  get canRead(): boolean {
    if (!this.featureFlags.isEnabled('visitors-disabled-sign-out')) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITORS_CONFIGURATION_READ);
  }

  get canManageEmployeeSignOutDisabled(): boolean {
    if (!this.featureFlags.isEnabled('visitors-disabled-sign-out')) return false;

    return this.authz.hasPermissionAtCurrentLocation(
      Permission.VISITORS_VISITORS_CONFIGURATION_MANAGE_EMPLOYEE_SIGN_OUT_DISABLED,
    );
  }
}
